// AI Generated Component
import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { CookieBannerRepoService } from '../../services/cookie-banner-repo.service';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';
import { COOKIE_CATEGORIES } from '@client/ng2/core/constants/cookie-categories.constant';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { DemoHasAccessService } from '@client/app/modules/demodata/services/demo-has-access.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import {
    CookieCategoriesLocalizeService,
} from '../../components/cookie-overview/categories-localize/cookie-categories-localize.service';

@Component({
    selector: 'page-details-cookie-acceptance-rate',
    standalone: false,
    template: `
        <div id="cookie-acceptance-rate-overview">
            <div class="alert alert-warning font-size-1-3 font-weight-500 justify-content-center row"
                 *ngIf="isDemo"
                 translate>
                Consent results are sample data for demo purposes
            </div>
            <page-header
                    [icon]="['SIDEMENUES', 'DATA_PRIVACY', 'CONSENT_OVERVIEW', 'COOKIE_BITE'] | monIcons"
                    header="{{'Cookie Acceptance Rate' | translate}}"
                    subHeader="{{subheaderTranslation}}">
                <page-header-content>
                    <statistics-date-picker
                            (onApply)="updateDateRange()"
                            [(date)]="date"
                            class="pull-right">
                    </statistics-date-picker>
                </page-header-content>
            </page-header>

            <div class="row mt-5 align-items-stretch">
                <div class="col-md-24 ">
                    <div class="card panel-monsido-card mb-0 d-flex flex-column">
                        <div class="card-header">
                            <h2 class="font-weight-300"
                                translate>
                                Acceptance Rate by Category
                            </h2>
                        </div>
                        <div class="card-body pt-0 flex-grow-1 row d-flex align-items-stretch">
                            <div class="col-48 py-2">
                                <mon-spinner [loading]="loading">
                                    <div class="row mt-3">
                                        <div class="col-48 pr-6">
                                            <div class="no-result-message-container"
                                                 *ngIf="categoriesArr.length === 0">
                                                <p class="d-flex justify-content-center font-weight-300 text-grey"
                                                >{{ 'No content was found' | translate }}</p>
                                            </div>
                                            <cookie-acceptance-rate
                                                    *ngFor="let category of categoriesArr"
                                                    [name]="category.name | capitalize"
                                                    [percentage]="category.percentage">
                                            </cookie-acceptance-rate>
                                        </div>
                                    </div>
                                </mon-spinner>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-24">
                    <div class="card panel-monsido-card mb-6 d-flex flex-column">
                        <div class="card-header">
                            <h2 class="font-weight-300"
                                translate>
                                Overall Acceptance Rate
                            </h2>
                        </div>
                        <div class="card-body pt-0 flex-grow-1 row d-flex align-items-stretch">
                            <div class="col-48 py-2">
                                <mon-spinner [loading]="loading">
                                    <div class="row mt-3">
                                        <div class="col-48 py-6 page-cookie-summary-doughnut-container inline-block">
                                            <mon-chart-doughnut
                                                    [size]="200"
                                                    [data]="doughnutData"
                                                    [labels]="doughnutLabels"
                                                    [colors]="doughnutColors"
                                                    [options]="doughnutOptions">
                                            </mon-chart-doughnut>
                                        </div>
                                    </div>

                                    <div class="row mt-3">
                                        <div class="card-header d-flex mb-1">
                                            <h4 class="font-weight-300"
                                                translate>Acceptance Rate Over Time</h4>
                                        </div>
                                        <div class="col-48 pr-6">
                                            <mon-chart-line
                                                    [height]="300"
                                                    [data]="lineChartData"
                                                    [series]="lineChartSeries"
                                                    [labels]="lineChartLabels"
                                                    [colors]="lineChartColors"
                                                    [options]="lineChartOptions"
                                                    [override]="lineChartOverride"
                                                    [emptyDataMessage]="'No data available' | translate">
                                            </mon-chart-line>
                                        </div>
                                    </div>
                                </mon-spinner>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PageDetailsCookieAcceptanceRateComponent implements OnInit {
    loading = true;
    subheaderTranslation: string;
    regulationsTitle = '';
    acceptanceRateString: string;
    lineChartSeries: string[];
    date: any;
    totalCount = 0;
    categoriesArr: any[] = [];
    lineChartData: any[] = [[]];
    lineChartLabels: any[] = [];
    lineChartColors: string[] = ['#34C6D0'];
    lineChartOptions: any = {};
    lineChartOverride: any[] = [];
    doughnutLabels: string[] = ['', ''];
    doughnutColors: string[] = ['#34C6D0', '#dcdcdc'];
    doughnutData: any[] = [];
    doughnutOptions: any = {};
    isDemo = false;

    constructor (
        private cookieBannerRepoService: CookieBannerRepoService,
        private dateTimeService: DateTimeService,
        private translateService: TranslateService,
        private pipeService: PipeService,
        private paramService: ParamService,
        private demoHasAccessService: DemoHasAccessService,
        private dateRangeService: DateRangeService,
        private cookieCategoriesLocalizeService: CookieCategoriesLocalizeService,
    ) {
        this.subheaderTranslation = this.translateService.getString('An overview of your customer\'s behavior with cookies on your website');
        this.acceptanceRateString = this.translateService.getString('Acceptance Rate');
        this.lineChartSeries = [this.acceptanceRateString];
    }

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.setupLineChart();
        this.date = this.dateRangeService.setRangeDates();
        this.updateDateRange();
        this.getStatisticsData();
    }

    updateDateRange (): void {
        const dateParams = this.paramService.returnPrevParam();
        if (
            !this.dateTimeService.isSame(dateParams.from, this.date.startDate) ||
            !this.dateTimeService.isSame(dateParams.to, this.date.endDate)
        ) {
            this.loading = true;
            this.getStatisticsData();
        }
        this.paramService.setParams({ from: moment(this.date.startDate), to: moment(this.date.endDate) });
    }

    getStatisticsData (): void {
        const request = {
            from: this.date.startDate,
            to: this.date.endDate,
        };
        this.isDemo = this.demoHasAccessService.isDemoConsentManager();
        if (this.isDemo) {
            this.updateStatisticsData(this.generateData());
            this.loading = false;
        } else {
            this.cookieBannerRepoService.getStatistics(request)
                .then((statistics: any) => {
                    this.updateStatisticsData(statistics);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    updateStatisticsData (statistics: any): void {
        this.totalCount = statistics.total_count || 0;
        const dailyTotalCountsArr = statistics.daily_total_counts || [];
        const categoriesMap = this.getCategoriesMap(statistics.daily_consent_counts);
        const dailyEssentialCountMap = this.getDailyEssentialCountsMap(statistics.daily_consent_counts);
        this.categoriesArr = this.getSortedCategoriesArr(categoriesMap);
        this.setupLineChartData(dailyEssentialCountMap, dailyTotalCountsArr);
        this.setupDoughnutChart(this.categoriesArr);
    }

    getSortedCategoriesArr (categoryMap: Map<string, any>): any[] {
        const categoriesArr: any[] = [];
        if (categoryMap.size) {
            categoryMap.forEach((categoryObj) => {
                if (categoryObj) {
                    categoriesArr.push({
                        name: categoryObj.category,
                        percentage: this.totalCount === 0 ? 0 : (categoryObj.count / this.totalCount) * 100,
                        order: categoryObj.order,
                    });
                }
            });
        }

        return categoriesArr.sort((a, b) => {
            const aOrder = a.order || 100;
            const bOrder = b.order || 100;

            if (aOrder < bOrder) {
                return -1;
            }

            if (aOrder > bOrder) {
                return 1;
            }

            return 0;
        });
    }

    setupLineChartData (dailyEssentialCountMap: Map<string, any>, dailyTotalCountsArr: any[]): void {
        this.setupLineChart();
        if (dailyEssentialCountMap.size && dailyTotalCountsArr.length) {
            dailyEssentialCountMap.forEach((el) => {
                const dailyTotalCount = dailyTotalCountsArr.find((day) => day.day === el.day);
                const simpleThreeValue = dailyTotalCount && dailyTotalCount.count !== 0 ? (el.count * 100) / dailyTotalCount.count : 0;
                this.lineChartData[0].push(simpleThreeValue.toFixed(2));
                this.lineChartLabels.push(moment(el.day).format('MMM DD'));
            });
        }
    }

    setupLineChart (): void {
        this.lineChartData = [[]];
        this.lineChartLabels = [];
        this.lineChartColors = ['#34C6D0'];
        this.lineChartOptions = {
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-0',
                        type: 'linear',
                        position: 'left',
                        grid: {
                            drawBorder: false,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.acceptanceRateString,
                            fontStyle: 400,
                        },
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: 4,
                            maxTicksLimit: 5,
                            callback: (value: any) => parseInt(value) + '%',
                            stepSize: 25,
                            min: 0,
                            max: 100,
                        },
                    },
                ],
                xAxes: [
                    {
                        id: 'x-axis-0',
                        gridLines: {
                            display: false,
                        },
                    },
                ],
            },
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    fontSize: 11,
                    boxWidth: 8,
                    boxHeight: 8,
                },
            },
        };

        this.lineChartOverride = [
            {
                type: 'line',
                fill: false,
                lineTension: 0,
                pointRadius: 3,
                pointHitRadius: 10,
            },
        ];
    }

    setupDoughnutChart (categoriesArr: any[]): void {
        this.doughnutLabels = ['', ''];
        this.doughnutColors = ['#34C6D0', '#dcdcdc'];
        this.doughnutData = [];
        if (categoriesArr.length) {
            // summing percentages from all categories
            const acceptanceRateSum = categoriesArr.reduce((acc, el) => {
                acc += el.percentage;
                return acc;
            }, 0);

            // getting the overallRate by diving sum over number of categories
            const overallRate = acceptanceRateSum / categoriesArr.length;
            this.doughnutData = [overallRate, 100 - overallRate];

            this.doughnutOptions = {
                centerText: {
                    percentageLabel: this.pipeService.get('monNumber')(overallRate / 100, '0.[00] %'),
                    totalLabel: this.translateService.getString('Overall acceptance rate'),
                    totalFontSize: 150,
                    subFontSize: 150,
                },
                cutoutPercentage: 80,
                tooltips: {
                    enabled: false,
                },
            };
        }
    }

    getCategoriesMap (dailyConsentCounts: any[]): Map<string, any> {
        const categoriesOrderMap = this.getCategoriesOrderMap();
        if (dailyConsentCounts && dailyConsentCounts.length) {
            return dailyConsentCounts.reduce((acc, el) => {
                // only handle cases where consent is !== null (i.e 'essential')
                if (el.consent !== null) {
                    if (!acc.has(el.consent)) {
                        acc.set(el.consent, {
                            count: el.count,
                            category: el.consent,
                            order: categoriesOrderMap.get(el.consent),
                        });
                    } else {
                        const count = acc.get(el.consent).count;
                        acc.set(el.consent, {
                            count: count + el.count,
                            category: el.consent,
                            order: categoriesOrderMap.get(el.consent),
                        });
                    }
                }
                return acc;
            }, new Map());
        }
        return new Map();
    }

    // getting daily essential counts for calculating acceptance rate over time for essential cookies
    getDailyEssentialCountsMap (dailyConsentCounts: any[]): Map<string, any> {
        if (dailyConsentCounts && dailyConsentCounts.length) {
            return dailyConsentCounts.reduce((acc, el) => {
                if (el.consent === COOKIE_CATEGORIES.essential) {
                    acc.set(el.day, { count: el.count, day: el.day });
                }
                return acc;
            }, new Map());
        }

        return new Map();
    }

    getCategoriesOrderMap (): Map<string, any> {
        const map = new Map();
        map.set(COOKIE_CATEGORIES.essential, {
            order: 1,
            name: this.cookieCategoriesLocalizeService[COOKIE_CATEGORIES.essential],
        });
        map.set(COOKIE_CATEGORIES.marketing, {
            order: 2,
            name: this.cookieCategoriesLocalizeService[COOKIE_CATEGORIES.marketing],
        });
        map.set(COOKIE_CATEGORIES.analytics, {
            order: 3,
            name: this.cookieCategoriesLocalizeService[COOKIE_CATEGORIES.analytics],
        });
        map.set(COOKIE_CATEGORIES.personalisation, {
            order: 4,
            name: this.cookieCategoriesLocalizeService[COOKIE_CATEGORIES.personalisation],
        });

        return map;
    }

    generateData (): any {
        return {
            daily_total_counts: [
                { day: '2021-07-26', count: 210 },
                { day: '2021-07-27', count: 75 },
            ],
            daily_consent_counts: [
                { day: '2021-07-26', consent: null, count: 163 },
                { day: '2021-07-26', consent: 'analytics', count: 18 },
                { day: '2021-07-26', consent: 'essential', count: 47 },
                { day: '2021-07-26', consent: 'marketing', count: 19 },
                { day: '2021-07-26', consent: 'personalisation', count: 19 },
                { day: '2021-07-27', consent: null, count: 20 },
                { day: '2021-07-27', consent: 'basic', count: 1 },
                { day: '2021-07-27', consent: 'analytics', count: 3 },
                { day: '2021-07-27', consent: 'essential', count: 55 },
                { day: '2021-07-27', consent: 'marketing', count: 3 },
                { day: '2021-07-27', consent: 'personalisation', count: 3 },
            ],
            total_count: 285,
        };
    }
}
